export class InventoryCellSprite extends KDCore.Sprite {
  constructor(index) {
    super();
    this.index = index;
    this._inSpecialState = false;
    this._isEquipedItem = false;
    this._isFavWeapon = false;
    this._isChestItem = false;
    this._pressTimer = 0;
    this.gpIndex = -1;

    this._create();
  }

  isLocked() {
    return (this._lockCellSpr) ? this._lockCellSpr.visible : false;
  }

  _create() {
    this._loadSettings();
    this._iconSprPlace = new Sprite();
    this._loadImages();
    this._createCell();
    this.add(this._iconSprPlace);

    this._createQualityLevelSpr();
    this._createSpecial();
    this._createCountText();
    this._createLockCellSprite();
    this._createFader();
  }

  _loadSettings() {
    this.settings = this._settingsJSON();
    this.customCellParams = YsServices.equipmentService.getSizeCellsParameter();
  }

  _loadImages() {
    this.slotBitmap = ImageManager.loadInv("InventorySlot_00");
    this.slotBitmap.addLoadListener(this._createIconSpr.bind(this));

    this._imgs0 = [this.slotBitmap, ImageManager.loadInv("InventorySlot_01"), ImageManager.loadInv("InventorySlot_00"), ImageManager.loadInv("InventorySlot_00")]; // * Default
    this._imgs2 = [ImageManager.loadInv("InventorySlotB_00"), ImageManager.loadInv("InventorySlotB_01"), ImageManager.loadInv("InventorySlotB_00"), ImageManager.loadInv("InventorySlotB_00")]; // * Equipment state
    this._imgs3 = [ImageManager.loadInv("InventorySlotC_00"), ImageManager.loadInv("InventorySlotC_01"), ImageManager.loadInv("InventorySlotC_00"), ImageManager.loadInv("InventorySlotC_00")]; // * FOCUS (and gamepad)
  }

  setFocusItem(item1, count) {
    this.item = item1;
    this.drawIconExt();
    this.drawCount(count);
    this.registerFocusClick();
    this.drawFocusFrame();
  };

  registerFocusClick() {
    this._cell._clickHandlers = [];
    this._cell.addClickHandler(() => {
      YsServices.equipmentService.onInvCellFocusedClick(this.index);
    });
  };

  drawFocusFrame() {
    this._cell.setButtonImages(...this._imgs3);
  };

  disableItem() {
    this._fader.visible = true;
  }

  registerClick() {
    this._cell._clickHandlers = [];
    this._cell.addClickHandler(() => {
      YsServices.equipmentService.onInvCellClick(this.index);
    });
  }

  enableItem() {
    this._fader.visible = false;
  };

  setItem(item) {
    this.item = item;
    if (this.item && !this.isLocked()) {
      this.drawIconExt();
      this.drawQualityLevel(DataManager.getItemQualityLevel(this.item));
      this.drawCount($gameParty.numItems(this.item));
      this.refreshSpecialState();
      this.registerClick();
    } else {
      this.clear();
    }
  }

  drawIconExt() {
    const extraImg = DataManager.getItemInvImage(this.item);
    if (String.any(extraImg)) {
      this.drawIcon(ImageManager.loadInv_Icon(extraImg));
    } else {
      this.drawIcon(this.item.iconIndex);
    }
  }

  clear() {
    this.item = null;
    this._checkUsableThread = null;
    this._isEquipedItem = false;
    this._isFavWeapon = false;
    this._fader.visible = false;
    this._isChestItem = false;
    this._cell._clickHandlers = [];

    this._clearSpeacialState();
    this.drawCount(0);
    this.drawIcon(0);
    this.drawQualityLevel(-1);
  }

  drawCount(count) {
    if (!this._textSpr) return;

    this._textSpr.clear();

    if(this.item?.id === 4) {
      return this._textSpr.drawTextFull(YS.Services.casinoService.chips, this.settings.cellItemCountText.position);
    }

    if (count > 1) {
      return this._textSpr.drawTextFull(count, this.settings.cellItemCountText.position);
    }
  }

  drawIcon(iconIndex) {
    if (!this._iconSpr) return;
    this._iconSpr.clear();

    if (iconIndex instanceof Bitmap || iconIndex > 0) {
      if (iconIndex instanceof Bitmap && !iconIndex.isReady()) {
        iconIndex.addLoadListener(() => {
          return this.drawIcon(iconIndex);
        });
      }

      if (this.customCellParams != null) {
        if (this.customCellParams.iconMode === 0) {
          this._iconSpr.bitmap.drawIcon(0, 0, iconIndex, 32);
        } else {
          this._iconSpr.bitmap.drawIcon(0, 0, iconIndex, this.slotBitmap.width - 8);
        }
      } else {
        this._iconSpr.bitmap.drawIcon(0, 0, iconIndex, 30);
      }
    }
  }

  refreshSpecialState() {
    if (!this.item ) return;

    this._checkUsableThread = null;
    if (DataManager.isItem(this.item)) {
      return this._refreshItemState();
    } else {
      return this._refreshEquipmentState();
    }
  }

  _createCell() {
    this._cell = new KDCore.Button();
    this._cell.setButtonImages(...this._imgs0);
    this.add(this._cell);
  }

  _createIconSpr() {
    if (this.customCellParams != null) {
      this._iconSpr = this._createCustomIconSpr();
    } else {
      this._iconSpr = KDCore.Sprite.FromBitmap(30, 30);
      this._iconSpr.move(4, 4);
    }

    this._iconSprPlace.addChild(this._iconSpr);

    if (this.item) {
      this.drawIconExt(this.item.iconIndex);
    }
  }

  _createCustomIconSpr() {
    let iconSpr;

    if (this.customCellParams.iconMode === 0) {
      iconSpr = KDCore.Sprite.FromBitmap(32);
      const width = this.slotBitmap.width;
      const height = this.slotBitmap.height;

      iconSpr.anchor.x = 0.5;
      iconSpr.anchor.y = 0.5;
      iconSpr.x = width / 2;
      iconSpr.y = height / 2;
    } else {
      iconSpr = KDCore.Sprite.FromBitmap(this.customCellParams.iconSize);
      iconSpr.move(4, 4);
    }

    return iconSpr;
  }

  _checkUsable() {
    this.partyUsecases = [];
    if (YsServices.equipmentService.get_AutoRefreshItems()) {
      this._onCheckUsableTick();
      this._checkUsableThread = new KDCore.TimedUpdate(20, this._onCheckUsableTick.bind(this));
    } else {
      return this._onCheckUsableTick();
    }
  };

  _createQualityLevelSpr() {
    if (!YsServices.equipmentService.get_AllowRareSystem()) return;

    this._rareSpr = new Sprite();
    this.add(this._rareSpr);
  }

  _createSpecial() {
    this._createSpecialSpr();
    this._createSpecialText();
  }

  _createSpecialSpr() {
    this._specialSpr = YsServices.equipmentService.FromImgI("InventorySlotA");
    this._specialSpr.move(KDCore.Utils.jsonPos(this.settings.invCellCornerPosition));
    this._specialSpr.visible = false;
    this.add(this._specialSpr);
  }

  _createSpecialText() {
    this._specialSprText = KDCore.Sprite.FromBitmap(this.settings.cellItemSpecialText.textBoxWidth, this.settings.cellItemSpecialText.textBoxHeight);
    this.applyTextSettingsByExtraSettings(this._specialSprText, this.settings.cellItemSpecialText);
    this._specialSpr.add(this._specialSprText);
  }

  _createCountText() {
    this._textSpr = KDCore.Sprite.FromBitmap(this.settings.cellItemCountText.textBoxWidth, this.settings.cellItemCountText.textBoxHeight);
    this.applyTextSettingsByExtraSettings(this._textSpr, this.settings.cellItemCountText);
    this.add(this._textSpr);
  }

  _refreshItemState() {
    if (this.isLocked()) {
      this.disableItem();
    }

    if (this.isEnabled()) {
      return this._checkUsable();
    }
  }

  _refreshEquipmentState() {
    const canEquip = $gameParty.leader().canEquip(this.item);
    if (!canEquip) {
      this.disableItem();
    }

    const equips = $gameParty.leader().equips();

    for (let i in equips) {
      const j = equips[i];

      if (j === this.item) {
        const equippedAlready = this._getUnequipCandidtaes()[this.item.id];
        if (equippedAlready) {
          continue;
        }

        this._setCandidateForUnequip($gameParty.leader().actorId());
        this._isEquipedItem = true;
        this._applyEquipmenSpecialState();
      }
    }
  }

  _applyEquipmenSpecialState() {
    this._applyEquipmentSpecialCellState();

    this._specialSprText.clear();
    this._specialSprText.drawTextFull(this.settings.cellEquipmentSymbol, this.settings.cellItemSpecialText.position);

    if (this._inSpecialState) {
      return this.drawCount(1);
    } else {
      return this.drawCount($gameParty.numItems(this.item));
    }
  }

  _applyEquipmentSpecialCellState() {
    this._inSpecialState = true;
    this._cell.setButtonImages(...this._imgs2);
    this._specialSpr.bitmap = ImageManager.loadInv('InventorySlotB');
    this._specialSpr.visible = true;
  }

  drawQualityLevel(level) {
    if (!this._rareSpr) return;

    if (level < 0) {
      this._rareSpr.bitmap = new Bitmap(1, 1);
      return;
    }

    this._rareSpr.bitmap = ImageManager.loadInv('QualityLevel_' + level);
  }

  isHovered() {
    return this._cell.isMouseInButton();
  }

  isEnabled() {
    return this._fader.visible === false;
  }

  _clearSpeacialState() {
    if (this._inSpecialState || this._inSpecialStateGP) {
      this._cell.setButtonImages(...this._imgs0);
      this._specialSpr.visible = false;
    }

    this._inSpecialState = false;
    this._inSpecialStateGP = false;
  }

  _createFader() {
    if (this.customCellParams != null) {
      this._fader = KDCore.Sprite.FromBitmap(this.customCellParams.iconSize);
    } else {
      this._fader = KDCore.Sprite.FromBitmap(30, 30);
    }
    this._fader.bitmap.fillAll(KDCore.Color.BLACK);
    this._fader.opacity = 120;
    this._fader.visible = false;
    this._fader.move(4, 4);
    return this.add(this._fader);
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  isCanBeUnEquiped() {
    return this._inSpecialState && this._isEquipedItem;
  }

  update() {
    KDCore.Sprite.prototype.update.call(this);

    if (this._checkUsableThread) {
      this._checkUsableThread.update();
    }

    if (TouchInput.isPressed() && this.isHovered()) {

    } else {
      return this._pressTimer = 0;
    }
  }

  prepareForCategory(categoryIndex) {
    this.categoryIndex = categoryIndex;
  }

  _createLockCellSprite() {
    this._lockCellSpr = new Sprite(ImageManager.loadInv("InventorySlot_locked"));
    this._lockCellSpr.visible = false;
    this.addChild(this._lockCellSpr);
  }

  _onCheckUsableTick() {
    //"CHECK USABLE FOR ITEM".p(@item.name)
    if (this.item.occasion === 1) { // * battle screen
      this.disableItem();
      return false;
    }

    if (this.item.scope === 0 && (this.item.occasion === 2 || this.item.occasion === 0)) {
      this.enableItem();
      return true;
    }

    const canUse = this._canActorUseItem($gameParty.leader());
    if (!canUse) {
      return this.disableItem();
    } else {
      return this.enableItem();
    }
  };

  _canActorUseItem(actor) {
    let result;
    const _Scene_Item = Scene_Item.prototype;

    this.user = function() {
      return actor;
    };

    const item = this.item;
    this.item = function() {
      return item;
    };

    this.isItemEffectsValid = function() {
      return _Scene_Item.isItemEffectsValid.call(this);
    };

    this._actorWindow = {};
    const actorIndex = $gameParty.allMembers().indexOf(actor);

    this._actorWindow.index = function() {
      return actorIndex;
    };

    this.itemTargetActors = function() {
      return _Scene_Item.itemTargetActors.call(this);
    };

    result = _Scene_Item.canUse.call(this);
    this.item = item;

    return result;
  };

}
